import { TFunction } from 'i18next';
import * as Yup from 'yup';
export const validationSchema = (t: TFunction) =>
  Yup.object({
    name: Yup.string().required(t('valid_err_required')),
    options: Yup.array()
      .of(
        Yup.object().shape({
          name: Yup.string().required(t('valid_err_required')),
          additionalPrice: Yup.number()
            .typeError(t('valid_err_3_decimals'))
            .test(
              'is-decimal',
              t('valid_err_3_decimals'),
              (value) =>
                value === undefined ||
                value === null ||
                /^\d+(\.\d{1,3})?$/.test(value.toString())
            )
            .min(0.0, t('valid_err_min_zero'))
            .required(t('valid_err_required')),
        })
      )
      .min(1, t('valid_err_add_required'))
      .required(t('valid_err_add_required')),
  });
export type ProductAddOnValidationSchemaType = ReturnType<
  typeof validationSchema
>;
